export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-elevator-54180c82db881511d45706f43ceb8968.svg";